import { render } from "./content-logs-view-active-page.vue?vue&type=template&id=059d0434"
import script from "./content-logs-view-active-page.vue?vue&type=script&lang=ts"
export * from "./content-logs-view-active-page.vue?vue&type=script&lang=ts"

import "./content-logs-view-active-page.vue?vue&type=style&index=0&id=059d0434&lang=less"
script.render = render

export default script